/**
 * Created by eriksundqvist on 21/10/16.
 */
import moment from 'moment';

const ROT_FRACTION = 0.7;
const RUT_FRACTION = 0.5;

export function calculateRotAmount (value) {
  return value * ROT_FRACTION;
}

export function calculateRutAmount (value) {
  return value * RUT_FRACTION;
}

export function getLowHourlySalaryAmount (user) {
  const birthdate = String(user.socialSecurityNr).substring(0, 8);
  var age = moment().diff(birthdate, 'years');

  switch (true) {
    case age < 17:
      return 96.5;
    case age < 18:
      return 107;
    case age < 19:
      return 111;
    case age < 20:
      return 120;
    default:
      return 134;
  }
}

export function removeCurrencyFromAmount (amountWithCurrency) {
  var billAmount = amountWithCurrency.replace(',', '.');
  billAmount = billAmount.match(/\d*.?\d{1,2}/);
  if (billAmount !== null) {
    billAmount = Number(billAmount.join(''));
  } else {
    billAmount = 0;
  }
  return billAmount;
}

// Rounds to 2 decimals by default. Omits decimals if the result is an integer.
export function toMoney (value, decimals = 2) {
  const rounded = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  if (parseInt(rounded) === rounded) {
    return rounded;
  } else {
    return rounded.toFixed(decimals);
  }
}

export function amountInclVat (amount, vat) {
  return amount + amount * (vat / 100);
}



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/amount/amount-helper.js
 **/